"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminPromoContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const c = (0, core_1.initContract)();
exports.adminPromoContract = c.router({
    getPromoCodes: {
        method: 'GET',
        path: '/codes',
        responses: {
            200: models_1.ZPromoCodeSelect.array(),
        },
    },
    addPromoCode: {
        method: 'POST',
        path: '/add-code',
        body: models_1.ZPromoCodeInsert,
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    deletePromoCode: {
        method: 'DELETE',
        path: '/delete-code/:code',
        pathParams: zod_1.z.object({ code: zod_1.z.string() }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    updatePromoCodeStatus: {
        method: 'POST',
        path: '/update-status/:code',
        pathParams: zod_1.z.object({ code: zod_1.z.string() }),
        body: zod_1.z.object({ status: zod_1.z.nativeEnum(dbEnums_1.PromoStatus) }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    getPromoRecurringForPlayer: {
        method: 'GET',
        path: '/recurring/:playerId',
        pathParams: zod_1.z.object({ playerId: zod_1.z.string() }),
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                code: zod_1.z.string(),
                created_at: zod_1.z.coerce.date(),
                reward_type: zod_1.z.string(),
                value_per_step: zod_1.z.number(),
                total_steps: zod_1.z.number(),
                remaining_steps: zod_1.z.number(),
                status: zod_1.z.nativeEnum(dbEnums_1.PromoRecurringStatus),
            })),
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=promo.admin.contract.js.map